import "../../css/portfolio.css";
import "../../css/portfolio_mobile.css";
import PortfolioS1 from "./portfolioS1";
import PortfolioS2 from "./portfolioS2";
const Portfolio = () => {
  return (
    <>
      <PortfolioS1 />
      <PortfolioS2 />
    </>
  );
};

export default Portfolio;
